import * as React from 'react';
import * as intl from 'react-intl-universal';
import ModalHelper, { Dialog } from './ModalHelper';
import { Radio, Select, message } from 'antd';
import { EXPORT_ROUTER } from 'pc-sales/constants/export';
const RadioGroup = Radio.Group;
const Option = Select.Option;

/**
 * @refactor
 */
export default (WrappedComponent: React.ComponentClass<any>): any =>
    class Export extends React.Component<any> {
        state: any = {
            type: 'single',
            size: '',
        };

        resetHandler = () => {
            this.setState({
                type: 'single',
                size: '',
            });
        };

        /**
         * 单选框事件处理
         */
        radioHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
            this.setState({ type: event.target.value });
        };

        /**
         * 下拉框事件处理
         */
        selectHandler = (value: string) => {
            this.setState({ size: value });
        };

        /**
         * 导出报表
         */
        exportHandler = async ({ page, pagesize, callback, multiple, newExportFlag }: any) => {
            const downloadLink = newExportFlag
                ? EXPORT_ROUTER.REPORT_DOWNLOAD_CENTER_NEW
                : EXPORT_ROUTER.REPORT_DOWNLOAD_CENTER;
            const { type, size } = this.state;
            // eslint-disable-next-line n/no-callback-literal
            const res = await callback(
                type === 'single'
                    ? { page, pagesize }
                    : { page: 1, pagesize, expectedTotalRecords: Number(size) || 10000 },
            );
            res && message.success(intl.getHTML('Component.ExportSuccess', { field: downloadLink }));
            this.resetHandler();
        };

        /**
         * 导出处理
         */
        trigger = async ({ counts, page, pagesize, callback, multiple = 1, newExportFlag = false }: any) => {
            if (!counts) {
                message.error(intl.get('Error.ExportParamsError'));
                return;
            }
            await ModalHelper.show({
                Dialog,
                config: {
                    title: intl.get('Component.ExportTitle'),
                    onOK: async () => {
                        await this.exportHandler({ page, pagesize, callback, multiple, newExportFlag });
                    },
                    onCancel: () => {
                        this.resetHandler();
                    },
                    content: (
                        <div>
                            <RadioGroup
                                onChange={(e: any) => {
                                    this.radioHandler(e);
                                }}
                                defaultValue={this.state.type}
                            >
                                <div>
                                    <Radio value="single" />
                                    <span>{intl.get('Component.ExportCurrent')}</span>
                                </div>
                                <div>
                                    <Radio value="all" />
                                    <span>
                                        {intl.get('Component.ExportSelectNum')}
                                        <Select
                                            defaultValue={`${10000 * multiple}`}
                                            onChange={this.selectHandler}
                                            style={{ margin: '12px' }}
                                            className="Wireframe"
                                        >
                                            <Option value={`${10000 * multiple}`}>{10000 * multiple}</Option>
                                            <Option value={`${20000 * multiple}`}>{20000 * multiple}</Option>
                                            <Option value={`${30000 * multiple}`}>{30000 * multiple}</Option>
                                            <Option value={`${40000 * multiple}`}>{40000 * multiple}</Option>
                                            <Option value={`${50000 * multiple}`}>{50000 * multiple}</Option>
                                        </Select>
                                        {intl.get('Component.ExportRow')}
                                    </span>
                                </div>
                            </RadioGroup>
                        </div>
                    ),
                    footer: 'all',
                },
            });
        };

        render() {
            return <WrappedComponent {...this.props} onExport={this.trigger} />;
        }
    };
